import {persistTelegramLaunchParams} from '@/utils/telegramLaunchParams.js'

const appTypes = {
  WEB: 'web',
  TELEGRAM: 'telegram',
}

/**
 * Sync TMA detection without importing @telegram-apps/sdk into the entry chunk.
 * Mirrors @telegram-apps/bridge isTMA() / retrieveRawLaunchParams sources:
 * location, performance navigation URL, sessionStorage cache, legacy WebApp, webview proxy.
 */
function detectTelegramEnv() {
  if (typeof window === 'undefined') {
    return false
  }

  if (window.Telegram?.WebApp) {
    return true
  }

  if (typeof window.TelegramWebviewProxy?.postEvent === 'function') {
    return true
  }

  const hasLaunchParams = (raw) => {
    if (!raw || typeof raw !== 'string') {
      return false
    }
    return (
      raw.includes('tgWebAppVersion=')
      || raw.includes('tgWebAppData=')
      || raw.includes('tgWebAppPlatform=')
    )
  }

  // Same as bridge ge(): strip path, flatten hash/search into query-like string
  const toQueryLike = (href) => href.replace(/^[^?#]*[?#]/, '').replace(/[?#]/g, '&')

  try {
    if (hasLaunchParams(toQueryLike(window.location.href))) {
      return true
    }

    const navEntry = performance.getEntriesByType?.('navigation')?.[0]
    if (navEntry?.name && hasLaunchParams(toQueryLike(navEntry.name))) {
      return true
    }

    const cached = sessionStorage.getItem('tapps/launchParams')
    if (cached && hasLaunchParams(cached)) {
      return true
    }
  } catch {
    // sessionStorage / performance may be unavailable
  }

  return false
}

const isTelegramEnv = detectTelegramEnv()

// До router: сохранить hash с tgWebApp*, иначе редирект на /welcome сотрёт launch params
if (isTelegramEnv) {
  persistTelegramLaunchParams()
}

let appType = isTelegramEnv ? appTypes.TELEGRAM : appTypes.WEB

/** @type {Promise<typeof import('@telegram-apps/sdk') | null> | null} */
let telegramSdkPromise = null

function loadTelegramSdk() {
  if (!isTelegramEnv) {
    return Promise.resolve(null)
  }

  if (!telegramSdkPromise) {
    telegramSdkPromise = import('@telegram-apps/sdk').then((telegramSDK) => {
      window.telegramSDK = telegramSDK

      try {
        telegramSDK.init()

        // Не вызываем expand(): режим compact/full задаётся настройкой бота в Telegram.

        if (telegramSDK.swipeBehavior.isSupported() && telegramSDK.swipeBehavior.mount()) {
          telegramSDK.swipeBehavior.disableVertical()
        }

        if (telegramSDK.backButton.isSupported() && telegramSDK.backButton.mount()) {
          telegramSDK.backButton.show()
        }
      } catch (e) {
        // not a fully ready Telegram WebApp
      }

      return telegramSDK
    })
  }

  return telegramSdkPromise
}

if (isTelegramEnv) {
  loadTelegramSdk()
}

export {appTypes, appType, loadTelegramSdk}
